module.exports = {
  title: 'Haptic Shared Element Transition with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-02-13',
  slug: 'inner-shared-transition',
  tags: ['reanimated', 'gesture-handler'],
};
